import {Empty} from "data/types/generics";
import {SQUAD_IMAGE_URL} from "data/constants";
import {IMatch} from "data/types/entities";
import {MatchUtils} from "data/utils/match";

export type NullOrEmpty<T> = T | undefined | null;

export function getDashedValue<T>(value: NullOrEmpty<T>, replacer = "-", match?: IMatch): string {
	if (match && MatchUtils.isScheduled(match) && !value) {
		return replacer;
	}
	if (value === null || value === undefined) {
		return replacer;
	}
	return String(value);
}

export function getImageFromBackend(path: Empty<string>): string {
	if (!path) {
		return "";
	}
	return `${SQUAD_IMAGE_URL}${path}.png?_=2`;
}
